import { createSelector } from '@reduxjs/toolkit';
import { selectOfferSelected } from 'component/page/detail/store/availabilitySelectorIndex';
import { SelectedOfferState } from 'component/page/detail/store/availabilityDEPRECATED.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';

interface StateProps {
    selectedOffer: SelectedOfferState;
    cms: CmsValue;
}

export type FloatingSidePanelProps = StateProps;

export const mapStateToProps = createSelector(selectConfigFromBootstrap, selectOfferSelected, (config, selectedOffer): StateProps => {
    const cms = config.cms;
    return {
        cms,
        selectedOffer,
    };
});
